const state = {
    adress: 'Россия г.Новосибирск, ул.Николаева 18, офис 2',
    phone: '8 800 3500 868',
    email: 'st@i868.ru'
}

export default {
    state
}


// WEBPACK FOOTER //
// ./src/store/modules/data/data.js